import React from 'react';
import _ from 'lodash';
import SimpleOption from './SimpleOption';
import { AccordionGroup, AccordionContent } from 'core/controls';
import OptionsAccordionHeader from './OptionsAccordionHeader';

const SimpleOptionGroup = props => {
  const {
    options,
    header,
    hidePrice,
    hideSingleCount,
    isOpenDefault,
    disableSingleOption,
    analyticsKey,
    analyticsKey2,
    id,
    onChange,
    onDetails
  } = props;

  if (options.length === 0) {
    return null;
  }

  const optionList = options.map(option => (
    <SimpleOption
      key={option.id}
      option={option}
      disabled={disableSingleOption && option.selected && options.length === 1}
      hidePrice={hidePrice}
      analyticsKey={analyticsKey || header}
      analyticsKey2={
        _.isFunction(analyticsKey2) ? analyticsKey2(option) : option.description
      }
      onChange={onChange}
      onDetails={onDetails}
    />
  ));

  return (
    <AccordionGroup id={id} isOpenDefault={isOpenDefault}>
      <OptionsAccordionHeader
        header={header}
        count={options.length}
        hideSingleCount={hideSingleCount}
      />
      <AccordionContent>{optionList}</AccordionContent>
    </AccordionGroup>
  );
};

export default SimpleOptionGroup;
